// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-toggle[data-v-78a19f52]:after{content:normal}.header-container[data-v-78a19f52]{align-content:center;display:flex;flex-flow:row wrap;justify-content:center;width:100%}.header-grid[data-v-78a19f52]{border-bottom:1px solid #d9d9d9;flex:0 0 100%;max-width:1230px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
